module.exports = __webpack_public_path__ + "img/Semua.95a55c28.png";